import axios from "axios";
import authService from "./authService";

const newInstance = axios.create({ baseURL: process.env.REACT_APP_API_URL_v2 })

newInstance.interceptors.request.use(async (config) => {
  const token = authService.getToken()
  const isTokenExpired = authService.isTokenExpired()
  if (token && isTokenExpired) {
    authService.removeToken()
    localStorage.removeItem('user')
    window.location.href = '/login'
  } else if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default newInstance;
